export default {
  // FRONT CONFIG
  debug: true,

  // Colors
  mainColor: '#466EC9',
  lightBlack: '#333',
  whiteColor: '#FFFFFF',
  mediumGrey: '#7D7D7D',
  lightMediumGrey: '#D7D7D7',
  lightGrey: '#F2F2F2',

  defaultModalStyles: {
    overlay: {
      backgroundColor       : 'rgba(0, 0, 0, 0.75)',
      zIndex                : '1',
      overflow              : 'auto',
    },
    content : {
      top                   : '50%',
      left                  : '50%',
      right                 : 'auto',
      bottom                : 'auto',
      width                 : 'fit-content',
      margin                : '0 auto',
      marginTop             : '1.5rem',
      height                : 'fit-content',
      outline               : 'none',
    }
  }
}


// WEBPACK FOOTER //
// ./src/config.js